import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer2-service.dev.onyxcentersource.com',
  hostname: 'pioneer2.dev.onyxcentersource.com',
  portalUrl: 'https://portal.dev.onyxcentersource.com',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
  allowApiDocs: true,
  emailValidation: true,
  agencyDashboardUrl: 'https://agency-dashboard2.dev.onyxcentersource.com',
  showAgencyDashboard: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.dev2.ts